import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { axiosGetCall, axiosPostCall } from '../../services/apisCall';
import Logger from '../../lib/Logger';
const logger = new Logger('kycListTable');
import { renderErrorMessage, renderSuccessMessage } from '../../lib/toastMessage';
import { CustomMenu } from '../../components/menu/customMenu';
import { Icon } from '@iconify/react';

// component
import { PaginationTable } from '../../components/tables/paginationTable';
import TableFilters from './tableFilter';
import { useSocket } from 'src/context/SocketContext';

//mui
import {
  TableCell,
  Chip,
  Box,
  List,
  ListItem,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Menu,
  styled,
  Typography,
} from '@mui/material';
import ActivityTable from './activityTable';
import LoggedInDevices from './LoggedInDevices';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

//mui icons
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { configFile } from '../../config';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { checkButtonAccess } from 'src/utils/common';
import { useNavigate } from 'react-router-dom';
import UserDetails from './details';
import BroadcastActions from './broadcast/broadcastActions';
import WhatsappActions from '../whatsapp/whatsappAction';
import Iconify from 'src/components/iconify';

const columns = [
  { id: 'userId', label: 'User ID', minWidth: 110, align: 'center' },
  { id: 'name', label: 'Name', minWidth: 110, align: 'center' },
  { id: 'email', label: 'Email', minWidth: 110, align: 'center' },
  { id: 'altEmail', label: 'Alt Email', minWidth: 110, align: 'center' },
  // { id: 'password', label: 'Password', minWidth: 110, align: 'center' },

  { id: 'mobile', label: 'Mobile', minWidth: 110, align: 'center' },
  { id: 'accountManagerName', label: 'Account Manager', minWidth: 110, align: 'center' },
  { id: 'createdBy', label: 'Created From', minWidth: 110, align: 'center' },
  // { id: "isGoogleLogin", label: "Google Login", minWidth: 110, align: "center" },
  { id: 'verified', label: 'Verified', minWidth: 110, align: 'center' },
  { id: 'createdAt', label: 'Created Date', minWidth: 110, align: 'center' },
  { id: 'permission', label: 'Permission', minWidth: 110, align: 'center' },
  { id: 'status', label: 'Status', minWidth: 110, align: 'center' },
  { id: 'deleted', label: 'Deleted', minWidth: 110, align: 'center' },
  { id: 'deepcallUserId', label: 'DeepCall UserId', minWidth: 110, align: 'center' },
  { id: 'actions', label: 'Action', minWidth: 20, align: 'center' },
];

const wColumns = [
  { id: 'product_id', label: 'Product ID', minWidth: 100, align: 'center' },
  { id: 'product_name', label: 'Product Name', minWidth: 110, align: 'center' },
  { id: 'plan_id', label: 'Plan ID', minWidth: 110, align: 'center' },
  { id: 'plan_name', label: 'Plan Name', minWidth: 110, align: 'center' },
  { id: 'price', label: 'Price', minWidth: 110, align: 'center' },
  { id: 'max_user', label: 'Max User', minWidth: 110, align: 'center' },
  { id: 'active', label: 'Status', minWidth: 110, align: 'center' },
  { id: 'actions', label: 'Action', minWidth: 110, align: 'center' },
];

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  // color: theme.palette.grey[200],
  gap: '8px',
}));
const productActions = [
  {
    key: 'Broadcast',
    accessKey: 'assignPlans',
    label: 'Broadcast Actions',
  },
  {
    key: 'WaApi',
    accessKey: 'addWhatsApp',
    label: 'Whatsapp Actions',
  },
  {
    key: 'SMS',
    accessKey: 'smsGatewayPageList',
    label: 'SMS Actions',
  },
];

const getTomorrowDateTimeLocal = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  return new Date(tomorrow.getTime() - tomorrow.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const ConsoleUserListTable = () => {
  const socket = useSocket();
  const { URL_MAPPER: { console: consoleUrl } = {} } = configFile;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [searchAfterStack, setSearchAfterStack] = useState([null]); // searchAfterStack[i] = cursor to fetch page i

  const [page1, setPage1] = useState(0);
  const [rowsPerPage1, setRowsPerPage1] = useState(10);
  const [rows1, setRows1] = useState([]);
  const [count1, setCount1] = useState(0);

  const [search, setSearch] = useState('');
  const [load, setLoad] = useState(true);
  const [networkError, setNetworkError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState('');
  const [openChangeAm, setOpenChangeAm] = useState(false);

  const [userDetails, setUserDetails] = useState({});
  const [openDetails, setOpenDetails] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [allAdmin, setAllAdmin] = useState([]);
  const [adminEmail, setAdminEmail] = useState('');

  const [newAdminEmail, setNewAdminEmail] = useState('');
  const [openActivity, setOpenActivity] = useState(false);
  const [openLoggedIn, setOpenLoggedIn] = useState(false);
  const [assignPlane, setAssignPlane] = useState(false);
  const [inputTab, setInputTab] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [errorNumber, setErrorNumber] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [expiryDateError, setExpiryDateError] = useState('');
  // Add these two state variables with your other state declarations
  const [selectedWorkspace, setSelectedWorkspace] = useState('default');
  const [workSpaceVirtualUserAccount, setWorkSpaceVirtualUserAccount] = useState([]);
  const [workSpaceData, setWorkSpaceData] = useState([]);
  const visibleActions = productActions.filter(
    ({ key, accessKey }) => checkButtonAccess(accessKey, 'w') && selectedUser?.products?.includes(key)
  );

  const [filterData, setFilterData] = useState({
    status: 'active',
    planId: '',
    productId: '',
  });
  const [licenseData, setLicenseData] = useState({
    total: 0,
    remaining: 0,
  });
  const [loadingLicenseData, setLoadingLicenseData] = useState(false);

  const navigate = useNavigate();

  const fetchAllAdmin = async () => {
    try {
      const { amEmail, result } = await axiosGetCall('getAllAdmin', { userId: selectedUser?.userId, includeAll: false });
      setAllAdmin(result);
      setAdminEmail(amEmail);
    } catch (error) {
      console.error('error in fetching admin', error);
    }
  };

  const getPlansList = async () => {
    const skip = rowsPerPage1 * page1;
    try {
      let params = { skip, limit: rowsPerPage1 };
      const statusMapper = {
        active: true,
      };

      const filter = JSON.parse(JSON.stringify(filterData));

      if (filter?.status) params.status = statusMapper[filterData?.status];
      delete filter.status;
      setNetworkError(false);

      params = { ...params, ...filter };

      const data = await axiosGetCall('getPlanList', params);
      setLoading(false);

      // const {
      //   planList: { result, total },
      //   products,
      // } = data;
      const { planList, count } = data;

      setRows1(planList);
      setCount1(count);
      if (planList?.length) setAssignPlane(true);
    } catch (error) {
      console.warn(error);
      setNetworkError(true);
      setRows1([]);
      setCount1(0);
      renderErrorMessage(error?.message);
    }
    setLoading(false);
  };

  const updateUserAdmin = async () => {
    try {
      const { message } = await axiosPostCall('updateUserAdmin', {
        userId: selectedUser?.userId,
        amEmail: newAdminEmail,
      });
      renderSuccessMessage(message);
      setOpenChangeAm(false);
      setNewAdminEmail('');
      handleClose();
      setLoad(true);
    } catch (error) {
      console.error('error in updating admin', error);
      renderErrorMessage(error?.message);
    }
  };

  const fetchLicenseData = async () => {
    if (!selectedUser?.userId || !selectedPlan?.plan_id) return;

    setLoadingLicenseData(true);
    try {
      const response = await axiosGetCall('getUserPlanAndComment', {
        params: {
          userId: selectedUser?.userId,
          planId: selectedPlan?.plan_id,
        },
      });

      setLicenseData({
        total: response.totalLicenses,
        remaining: response.remaining,
      });
      setWorkSpaceVirtualUserAccount([...(response?.workSpaceList?.result?.map((w) => w.workspace) || [])]);
      setWorkSpaceData(response?.workSpaceList?.result || []);
    } catch (error) {
      console.error('Failed to fetch license data:', error);
      renderErrorMessage('Failed to load license information');
    } finally {
      setLoadingLicenseData(false);
    }
  };

  const handleChangeAmClick = async () => {
    await fetchAllAdmin();
    setOpenChangeAm(true);
  };

  const handleChangeWorkSpacePlane = async () => {
    await getPlansList();
    setAnchorEl(null);
  };

  const handleSelectChange = (e) => {
    setNewAdminEmail(e.target.value);
  };

  const handleUserDetailsUpdate = () => {
    return navigate('/updateUser', { state: { userDetails: selectedUser, edit: true } });
  };

  const handleChange = (value) => setSearch(value);

  const getConsoleUserList = async () => {
    try {
      const cursor = searchAfterStack[page] ?? null;
      const params = { limit: rowsPerPage };
      if (search) params.email = search;
      if (cursor) params.searchAfter = JSON.stringify(cursor);
      setNetworkError(false);
      const { usersList, count, lastSort } = await axiosGetCall('consoleUsersList', params);
      const formattedUsersList = usersList?.map((user) => ({
        ...user,
        status: user.status || "deActivate",
        deleted: user.deleted === true ? 'Deleted' : null,
      }));

      setRows(formattedUsersList);
      setCount(count);
      if (lastSort) {
        setSearchAfterStack(prev => {
          const updated = [...prev];
          updated[page + 1] = lastSort;
          return updated;
        });
      }
    } catch (error) {
      logger.error('ConsoleUserList.jsx ,getConsoleUserList ,consoleUsersList', error);
      setNetworkError(true);
      setRows([]);
      setCount(0);
      renderErrorMessage(error?.message);
    }
    setLoading(false);
  };

  const handleSetRowsPerPage = (newValue) => {
    setSearchAfterStack([null]);
    setRowsPerPage(newValue);
  };

  const handleSearchLoad = () => {
    setSearchAfterStack([null]);
    setPage(0);
    setLoad(true);
  };

  useEffect(() => {
    if (load) {
      setLoading(true);
      getConsoleUserList();
      setLoad(false);
    }
  }, [load]);
  useEffect(() => {
    if (inputTab) {
      fetchLicenseData();
    }
  }, [inputTab, selectedUser, selectedPlan]);
  useEffect(() => {
    if (inputTab && inputValue) {
      // Re-validate the input value when workspace changes
      const numValue = parseInt(inputValue);
      if (!isNaN(numValue)) {
        const remainingLicenses =
          selectedWorkspace === 'default'
            ? licenseData.remaining
            : workSpaceData.find((w) => w.workspace === selectedWorkspace)?.remaining || 0;

        if (numValue < 0 && Math.abs(numValue) > remainingLicenses) {
          setErrorNumber(`Cannot reduce below zero (remaining: ${remainingLicenses})`);
        } else {
          setErrorNumber('');
        }
      }
    }
  }, [selectedWorkspace, inputTab, inputValue, licenseData, workSpaceData]);
  const handleClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleClickWorkspaceAction = (e, value) => {
    setSelectedPlan(value);
    e.stopPropagation();
    setInputTab(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const refLogin = async () => {
    try {
      setAnchorEl(null);
      const { refToken = '', eToken } = await axiosPostCall('consoleReferenceLogin', { userId: selectedUser?.email });

      // renderSuccessMessage("Please wait, redirecting...");
      const finalUrl = consoleUrl + "/customSession?refToken=" + refToken  + "&eToken=" + btoa(eToken) ;
      window.open(finalUrl);
      return;
    } catch (error) {
      logger.error('refLogin error: ', error);
      return renderErrorMessage(error?.message || 'Internel server error!');
    }
  };

  const handleViewDetailsClick = async () => {
    try {
      const { userDetails } = await axiosGetCall('consoleUserDetails', { userId: selectedUser?.userId });
      setUserDetails(userDetails);
      setOpenDetails(true);
    } catch (error) {
      logger.error(error);
    }
  };

  const updateForceVerifyPermission = async () => {
    try {
      setAnchorEl(null);
      const { message } = await axiosPostCall('updateForceVerifyPermission', {
        updatedPermission: !selectedUser?.allowToForceVerify,
        email: selectedUser?.email,
      });
      renderSuccessMessage(message);
      getConsoleUserList();
    } catch (error) {
      logger.error('refLogin error: ', error);
      return renderErrorMessage(error?.message || 'Internel server error!');
    }
  };

  const tableFilter = (
    <TableFilters search={search} handleChange={handleChange} setLoad={handleSearchLoad} count={count} setPage={setPage} />
  );

  const ActionJsx = (id, align, value, ...other) => {
    const user = other[3];

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          size: 'small',
        }}
      >
        <MoreVertIcon
          sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
          aria-controls={open ? 'filters-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={(e) => handleClick(e, user)}
        />
      </TableCell>
    );
  };

  const WActionJsx = (id, align, value, ...other) => {
    const plane = other[3];

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          size: 'small',
        }}
      >
        <MoreVertIcon
          sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
          aria-controls={open ? 'filters-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={(e) => handleClickWorkspaceAction(e, plane)}
        />
      </TableCell>
    );
  };

  const amActions = () => {
    return (
      <Button
        variant="outlined"
        color="primary"
        onClick={updateUserAdmin}
        disabled={!checkButtonAccess('updateConsoleAdmin', 'w')}
      >
        Update
      </Button>
    );
  };

  const AmContant = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          gap: '17px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          mt: '8px',
        }}
      >
        {adminEmail && (
          <>
            <TextField
              id="outlined-basic"
              value={adminEmail}
              label="Old Account Manager"
              variant="outlined"
              fullWidth
              disabled
            />

            <Icon icon="ion:arrow-down-outline" style={{ color: 'blue', width: '20px', height: '27px' }} />
          </>
        )}

        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select New Account Manager</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={newAdminEmail}
            label="Select New Account Manager"
            onChange={handleSelectChange}
          >
            {allAdmin.map((email) => {
              return (
                <MenuItem key={email} value={email}>
                  {email}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
    );
  };

  const Content = () => {
    const [productAnchorEl, setProductAnchorEl] = useState(null);
    const [currentActionProduct, setCurrentActionProduct] = useState(null);
    const openProductMenu = Boolean(productAnchorEl);

    const handleCloseProductMenu = () => {
      setProductAnchorEl(null);
      handleClose();
    };

    const handleClickProductMenu = (id) => {
      setCurrentActionProduct(id);
      setProductAnchorEl(null);
    };

    useEffect(() => {
      if (currentActionProduct === 'SMS') {
        navigate('/smsPlanAssign', {
      state: {
        currentActionProduct,
        user: selectedUser,
      },
    });
      }
    }, [currentActionProduct]);

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <List>
          <ListItem
            sx={{
              display: 'flex',
              gap: '7px',
              fontWeight: 400,
              color: 'grey.700',
              '&:hover': {
                color: 'grey.800',
                backgroundColor: 'grey.300',
                cursor: 'pointer',
              },
            }}
            onClick={() => handleViewDetailsClick()}
          >
            <Icon icon="pajamas:details-block" style={{ color: 'green', width: '16px', height: '16px' }} />
            Details
          </ListItem>
          <ListItem
            sx={{
              display: 'flex',
              gap: '7px',
              fontWeight: 400,
              color: 'grey.700',
              '&:hover': {
                color: 'grey.800',
                backgroundColor: 'grey.300',
                cursor: 'pointer',
              },
            }}
            onClick={() => {
              setAnchorEl(null);
              setOpenActivity(true);
            }}
          >
            <Icon icon="mdi:chart-timeline-variant" style={{ color: 'green', width: '16px', height: '16px' }} />
            Activity
          </ListItem>
          <ListItem
            sx={{
              display: 'flex',
              gap: '7px',
              fontWeight: 400,
              color: 'grey.700',
              '&:hover': {
                color: 'grey.800',
                backgroundColor: 'grey.300',
                cursor: 'pointer',
              },
            }}
            onClick={() => {
              setAnchorEl(null);
              setOpenLoggedIn(true);
            }}
          >
            <Icon icon="mdi:devices" style={{ color: 'green', width: '16px', height: '16px' }} />
            Logged In Devices
          </ListItem>

          {checkButtonAccess('refLogin', 'w') && (
            <ListItem
              sx={{
                display: 'flex',
                gap: '7px',
                fontWeight: 400,
                color: 'grey.700',
                '&:hover': {
                  color: 'grey.800',
                  backgroundColor: 'grey.300',
                  cursor: 'pointer',
                },
              }}
              onClick={() => refLogin()}
            >
              <Icon icon="ant-design:login-outlined" style={{ color: 'blue' }} />
              Ref-login
            </ListItem>
          )}

          {checkButtonAccess('createConsoleuser', 'w') && (
            <ListItem
              sx={{
                display: 'flex',
                gap: '7px',
                fontWeight: 400,
                color: 'grey.700',
                '&:hover': {
                  color: 'grey.800',
                  backgroundColor: 'grey.300',
                  cursor: 'pointer',
                },
              }}
              onClick={() => handleUserDetailsUpdate()}
            >
              <Icon icon="clarity:update-line" style={{ color: 'green', width: '16px', height: '16px' }} />
              Update
            </ListItem>
          )}

          {selectedUser?.permission === 'l4' && checkButtonAccess('updateForceVerifyPermission', 'r') && (
            <ListItem
              sx={{
                display: 'flex',
                gap: '7px',
                fontWeight: 400,
                color: 'grey.700',
                '&:hover': {
                  color: 'grey.800',
                  backgroundColor: 'grey.300',
                  cursor: 'pointer',
                },
              }}
              onClick={() => updateForceVerifyPermission()}
            >
              <Icon icon="bitcoin-icons:verify-outline" style={{ color: 'blue', width: '25px', height: '27px' }} />
              {selectedUser?.allowToForceVerify ? 'Disable' : 'Enable'} force verify action
            </ListItem>
          )}
          {checkButtonAccess('updateConsoleAdmin', 'r') && (
            <ListItem
              sx={{
                display: 'flex',
                gap: '7px',
                fontWeight: 400,
                color: 'grey.700',
                '&:hover': {
                  color: 'grey.800',
                  backgroundColor: 'grey.300',
                  cursor: 'pointer',
                },
              }}
              onClick={() => handleChangeWorkSpacePlane()}
            >
              <Iconify icon="stash:plan" style={{ color: 'blue' }} />
              Workspace Plan
            </ListItem>
          )}

          {checkButtonAccess('updateConsoleAdmin', 'r') && (
            <ListItem
              sx={{
                display: 'flex',
                gap: '12px',
                fontWeight: 400,
                color: 'grey.700',
                '&:hover': {
                  color: 'grey.800',
                  backgroundColor: 'grey.300',
                  cursor: 'pointer',
                },
              }}
              // onClick={() => updateForceVerifyPermission()}
              onClick={() => handleChangeAmClick()}
            >
              <Icon icon="radix-icons:update" style={{ color: 'blue', width: '16px', height: '16px' }} />
              Assign AM
            </ListItem>
          )}

          <ListItem
            sx={{
              display: 'flex',
              gap: '12px',
              fontWeight: 400,
              color: 'grey.700',
              '&:hover': {
                color: 'grey.800',
                backgroundColor: 'grey.300',
                cursor: 'pointer',
              },
            }}
            // onClick={() => updateForceVerifyPermission()}
            onClick={(e) => {
              setProductAnchorEl(e.currentTarget);
            }}
          >
            <Icon icon="bitcoin-icons:transactions-outline" style={{ color: 'blue', width: '18px', height: '20px' }} />
            Product Actions
          </ListItem>
        </List>
        {visibleActions.length > 0 && (
          <Menu
            id="menu-productActions"
            anchorEl={productAnchorEl}
            open={openProductMenu}
            onClose={handleCloseProductMenu}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={{
              vertical: 'left',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{ padding: '0px' }}
          >
            {visibleActions.map(({ key, label }) => (
              <CustomMenuItem key={key} onClick={() => handleClickProductMenu(key)}>
                {label}
              </CustomMenuItem>
            ))}
          </Menu>
        )}{' '}
        {visibleActions.length > 0 && (
          <Menu
            id="menu-productActions"
            anchorEl={productAnchorEl}
            open={openProductMenu}
            onClose={handleCloseProductMenu}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={{
              vertical: 'left',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{ padding: '0px' }}
          >
            {visibleActions.map(({ key, label }) => (
              <CustomMenuItem key={key} onClick={() => handleClickProductMenu(key)}>
                {label}
              </CustomMenuItem>
            ))}
          </Menu>
        )}
        {currentActionProduct === 'Broadcast' && (
          <BroadcastActions
            currentActionProduct={currentActionProduct}
            setCurrentActionProduct={setCurrentActionProduct}
            user={selectedUser}
          />
        )}
        {currentActionProduct === 'WaApi' && (
          <WhatsappActions
            currentActionProduct={currentActionProduct}
            setCurrentActionProduct={setCurrentActionProduct}
            user={selectedUser}
          />
        )}
        <ConfirmDialog
          open={openChangeAm}
          onClose={() => {
            setOpenChangeAm(false);
            setNewAdminEmail('');
            handleClose();
          }}
          title={'Change Account Manager'}
          content={<AmContant userId={selectedUser?.userId} />}
          action={amActions()}
        />
        <UserDetails
          data={userDetails}
          openDetails={openDetails}
          setOpenDetails={setOpenDetails}
          handleClose={handleClose}
        />
      </Box>
    );
  };

  const ActionModals = () => {
    return <CustomMenu anchorEl={anchorEl} handleClose={handleClose} Content={Content} />;
  };

  const tableContent = (
    <PaginationTable
      page={page1}
      ActionJsx={WActionJsx}
      ActionModals={ActionModals}
      setLoad={setLoad}
      setPage={setPage1}
      rowsPerPage={rowsPerPage1}
      setRowsPerPage={setRowsPerPage1}
      count={count1}
      error={networkError}
      loading={loading}
      setLoading={setLoading}
      rows={rows1}
      columns={wColumns}
      handleChange={handleChange}
      search={search}
      calculatedHeight={377}
    />
  );

  const handleChangeNumber = (e) => {
    const value = e.target.value;
    if (value === '-' || value === '') {
      setErrorNumber('Please enter a valid number');
      setInputValue(value);
      return;
    }
    if (/^-?\d+$/.test(value)) {
      const numValue = parseInt(value);
      const totalLicenses =
        selectedWorkspace === 'default'
          ? licenseData.total
          : workSpaceData.find((w) => w.workspace === selectedWorkspace)?.totalLicenses || 0;
      const remainingLicenses =
        selectedWorkspace === 'default'
          ? licenseData.remaining
          : workSpaceData.find((w) => w.workspace === selectedWorkspace)?.remaining || 0;
      if (numValue < 0 && Math.abs(numValue) > remainingLicenses) {
        setErrorNumber(`Cannot reduce below zero (remaining: ${remainingLicenses})`);
      } else {
        setErrorNumber('');
      }

      setInputValue(value);
    } else {
      // Invalid input (not a number)
      setErrorNumber('Only numeric values are allowed');
    }
  };

  // const inputContent = (
  //   <Box sx={{ p: 2 }}>
  //     <TextField
  //       label="Enter number of licenses"
  //       variant="outlined"
  //       value={inputValue}
  //       onChange={handleChangeNumber}
  //       error={errorNumber}
  //       helperText={errorNumber ? 'Only numeric values are allowed' : ''}
  //       fullWidth
  //     />
  //   </Box>
  // );

  const inputContent = (
    <Box sx={{ p: 1, pt: 0, mt: 0 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        No Of License
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          mb: 3,
          paddingX: 1,
        }}
      >
        <FormControl fullWidth sx={{ ml: -5, width: 140 }}>
          <InputLabel>Workspace</InputLabel>
          <Select value={selectedWorkspace} label="Workspace" onChange={(e) => setSelectedWorkspace(e.target.value)}>
            {workSpaceVirtualUserAccount?.map((workspace) => (
              <MenuItem key={workspace} value={workspace}>
                {workspace}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              backgroundColor: '#f0f0f0',
              color: 'black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
            }}
          >
            T:{' '}
            {selectedWorkspace === 'default'
              ? licenseData.total
              : workSpaceData.find((w) => w.workspace === selectedWorkspace)?.totalLicenses || 0}
          </Box>
          <Typography variant="caption"></Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              backgroundColor: '#f0f0f0',
              color: 'black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
            }}
          >
            R:{' '}
            {selectedWorkspace === 'default'
              ? licenseData?.remaining
              : workSpaceData.find((w) => w.workspace === selectedWorkspace)?.remaining || 0}
          </Box>
          <Typography variant="caption"></Typography>
        </Box>
      </Box>

      {/* License input field */}
      <TextField
        label="Enter number of licenses"
        variant="outlined"
        value={inputValue}
        onChange={handleChangeNumber}
        error={!!errorNumber}
        helperText={errorNumber ? errorNumber : ''}
        fullWidth
      />
      <TextField
        label="Expiry date"
        type="datetime-local"
        variant="outlined"
        value={expiryDate}
        onChange={(e) => {
          setExpiryDate(e.target.value);
          setExpiryDateError('');
        }}
        error={!!expiryDateError}
        helperText={expiryDateError}
        fullWidth
        InputLabelProps={{ shrink: true }}
        inputProps={{ min: getTomorrowDateTimeLocal() }}
        sx={{ mt: 2 }}
      />
    </Box>
  );

  const assingPlane = () => {
    if (!expiryDate) {
      setExpiryDateError('Please select expiry date.');
      return;
    }

    const parsedExpiryDate = new Date(expiryDate);
    if (Number.isNaN(parsedExpiryDate.getTime())) {
      setExpiryDateError('Please select a valid expiry date.');
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedExpiryDate = new Date(parsedExpiryDate);
    selectedExpiryDate.setHours(0, 0, 0, 0);

    if (selectedExpiryDate <= today) {
      setExpiryDateError('Expiry date should be greater than today.');
      return;
    }

    const expiry_date = parsedExpiryDate.toISOString();
    const workspaceObj = workSpaceData.find((w) => w.workspace === selectedWorkspace);
    const virtualUserId = selectedWorkspace !== 'default' ? workspaceObj?.userId : null;
    if (socket) {
      socket.emit(
        'assignWorkSpacePlane',
        { selectedPlan, inputValue, selectedUser, workspace: selectedWorkspace, virtualUserId, expiry_date },
        (err, data) => {
          setInputTab(false);
          setErrorNumber('');
          setExpiryDateError('');
          if (err) return renderErrorMessage(err.message || 'Somthing went wrong!');

          setSelectedPlan('');
          setInputValue('');
          setExpiryDate('');
          setSelectedWorkspace('default');
          renderSuccessMessage(data?.message);
        }
      );
    }
  };

  const onSendPlane = () => {
    return (
      <Button
        variant="outlined"
        color="primary"
        onClick={assingPlane}
        disabled={!checkButtonAccess('updateConsoleAdmin', 'w')}
      >
        Send
      </Button>
    );
  };

  const selctPlaneAction = () => {};

  return (
    <>
      {/* <ToastContainer /> */}
      <PaginationTable
        page={page}
        tableFilter={tableFilter}
        ActionJsx={ActionJsx}
        ActionModals={ActionModals}
        setLoad={setLoad}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={handleSetRowsPerPage}
        count={count}
        error={networkError}
        loading={loading}
        setLoading={setLoading}
        rows={rows}
        columns={columns}
        handleChange={handleChange}
        search={search}
        calculatedHeight={288}
        deleted={(id, align, value) => (
          <TableCell
            key={id}
            align={align}
            sx={{ color: 'grey.700', borderBottom: '0.5px dashed', borderColor: 'grey.300' }}
          >
            {value === 'Deleted' ? (
              <Chip
                label="Deleted"
                color="error"
                size="small"
                sx={{ fontWeight: 500, minWidth: '70px' }}
              />
            ) : '--'}
          </TableCell>
        )}
      />
      <Dialog open={openActivity} onClose={() => setOpenActivity(false)} maxWidth="md" fullWidth>
        <DialogTitle>User Activity</DialogTitle>
        <DialogContent>
          <ActivityTable email={selectedUser?.email} />
        </DialogContent>
      </Dialog>

      <Dialog open={openLoggedIn} onClose={() => setOpenLoggedIn(false)} maxWidth="md" fullWidth>
        <DialogTitle>Logged In Devices</DialogTitle>
        <DialogContent>
          <LoggedInDevices email={selectedUser?.email} />
        </DialogContent>
      </Dialog>
      <ConfirmDialog
        open={assignPlane}
        onClose={() => {
          setAssignPlane(false);
        }}
        title={'Update Workspace Plan'}
        content={tableContent}
        maxWidth="lg"
      />
      <ConfirmDialog
        open={inputTab}
        onClose={() => {
          setInputTab(false);
          setExpiryDateError('');
        }}
        content={inputContent}
        action={onSendPlane()}
      />
    </>
  );
};
